module.exports = __webpack_public_path__ + "img/16_62.e89bc206.png";